// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wishlist-page__header{align-items:center;display:flex;justify-content:space-between;margin-bottom:var(--spacing-large)}.wishlist-page__empty-state,.wishlist-page__spinner{margin:190px auto;max-width:300px}@media(min-width:1024px){.wishlist-page__empty-state,.wishlist-page__spinner{margin:100px auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
